import React, { useState } from "react";
import { toast } from "react-toastify";

import ModalPaymentTerm from "./ModalPaymentTerm";
import { hasPermission } from "../../services/auth";

// Mesma regra do PaymentTerm::scopeForUsage + active do backend.
const fitsUsage = (term, usage) => term.active && (!usage || term.usage === 'both' || term.usage === usage);

/**
 * "+ Nova condição" no fim de um select de condição de pagamento: espalhe
 * `selectProps` no InputSelect e renderize `modal` ao lado. `created` recebe
 * a condição nova quando ela serve para o select (`usage` dele).
 */
export const useNewPaymentTerm = ({ usage = null, created, level }) => {
    const [show, setShow] = useState(false);

    if (!hasPermission('payment_terms')) return { selectProps: {}, modal: null };

    const saved = term => {
        setShow(false);

        if (!fitsUsage(term, usage)) {
            toast.info('A condição foi salva, mas não está disponível para este documento.');
            return;
        }

        created(term);
    };

    return {
        selectProps: { onCreate: () => setShow(true), createText: 'Nova condição' },
        modal: <ModalPaymentTerm show={show} close={() => setShow(false)} saved={saved} level={level} />,
    };
};

export default useNewPaymentTerm;
